"use client";

interface FeatureImageProps {
  src: string;
  alt: string;
  fallbackText: string;
}

export function FeatureImage({ src, alt, fallbackText }: FeatureImageProps) {
  return (
    <div className="relative rounded-lg overflow-hidden shadow-lg w-full aspect-[4/3] bg-plantista-100">
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover"
        onError={(e) => {
          e.currentTarget.style.display = "none";
          if (e.currentTarget.parentElement) {
            e.currentTarget.parentElement.classList.add(
              "bg-plantista-200",
              "flex",
              "items-center",
              "justify-center"
            );
            e.currentTarget.parentElement.innerHTML = `
              <div class="text-plantista-400 text-center px-4">
                <svg class="w-16 h-16 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
                <p class="text-sm font-medium font-sans">${fallbackText}</p>
              </div>
            `;
          }
        }}
      />
    </div>
  );
}
